export default __webpack_public_path__ + "assets/25d7f791fc551a40791f9b8b3af99632.svg";